import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { CreateMultipleCoBorrowersStepComponent } from "../../wizard/wizard-steps/create-multiple-coborrowers/create-multiple-coborrowers-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class CreateMultipleCoBorrowersStep extends WizardStepBase {

  restrictMiddleNameToSingleCharacter: boolean = false;

  forceCoborrowersIntoSameApplication: boolean = false;

  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = CreateMultipleCoBorrowersStepComponent;
  }
}
